import { LANGUAGE_CODE_OPTIONS } from './list';

export interface HelpDocument {
	id: number;
	serviceCode: string;
	titleDescription: string;
	title: string;
	sequence: number;
	files: HelpDocumentFile[];
}

export type FieldOfHelpDocument = keyof HelpDocument;

export const HELP_DOCUMENT_FIELD: FieldOfHelpDocument[] =
	['serviceCode', 'title', 'files', 'sequence', 'id'];

export interface HelpDocumentFile {
	id: number;
	fileName: string;
	title: string;
	lang: keyof typeof LANGUAGE_CODE_OPTIONS;
	type: string;
}
